import languages from '../languages';
import { getJSON, PASSPORT_HOST } from '../ultile';
import { errorReport, ERROR_TYPE } from '@utiles/errorReport';
import globalConfig from '../../utiles/globalConfig';
import { updateDefaultParam } from '../../plugins/AnalyzePoint';
import logoConfig from '../logoConfig';
import webStoreCoupon from './webStoreCoupon';

import { filterPayType } from '../_tempAllStoreHanlder';
const mainHost = globalConfig.getMainHost();

languages.init();

export const UPDATE_GAME_LIST = 'update_game_list';
export const UPDATE_GAME_HISTORY = 'update_game_history';
export const UPDATE_GAMEID = 'update_gameid';
export const UPDATE_USER_ACCOUNT_STATE = 'update_user_account_state';
export const UPDATE_USER_PASSWORD_STATE = 'update_user_password_state';
export const UPDATE_USER_REPASSWORD_STATE = 'update_user_repass_state';
export const UPDATE_REGISTER_TERM_STATE = 'update_register_term_state';
export const UPDATE_USER_ACCOUNT = 'update_user_account';
export const UPDATE_USER_PASSWORD = 'update_user_password';
export const UPDATE_USER_REPASSWORD = 'update_user_repass';
export const UPDATE_LOGIN_REQUEST = 'update_login_request';
export const UPDATE_REGISTER_REQUEST = 'update_register_request';
export const UPDATE_REMEMBER = 'update_remember';
export const UPDATE_USER_INFO = 'update_user_info';
export const RESET_USER_INFO = 'reset_user_info';
export const GET_SEPC_GAME_INFO = 'get_spec_game_info';
export const UPDATE_UID = 'update_uid';
export const UPDATE_LASTED_ROLE = 'update_lasted_role';

export const RESET_DATA = 'reset_data';

export const JUDGE_USER_ACCOUNT = 'judge_user_account';
export const JUDGE_USER_PASSWORD = 'judge_user_password';
export const JUDGE_USER_REPASSWORD = 'judge_user_repassword';
export const JUDGE_IS_LOGIN = 'judge_is_login';
export const JUDGE_REGISTER_TERM = 'judge_register_term';

export const GO_LOGIN = 'go_login';
export const GO_LOGOUT = 'go_logout';
export const GOTO_REGISTER = 'goto_register';
export const GOTO_LOGIN = 'goto_login';
export const LOGIN_CHECK = 'login_check';
export const REGISTER_CHECK = 'register_check';
export const GO_THIRD_LOGIN = 'go_third_login';
export const GO_BACK_SELECT_GAME = 'go_back_select_game';
export const GET_SERVER_LIST = 'get_server_list';
export const GET_ROLE_LIST = 'get_role_list';
export const UPDATE_SERVER_LIST = 'update_server_list';
export const UPDATE_HISTORY_SERVER_LIST = 'update_history_server_list';
export const UPDATE_ROLE_LIST = 'update_role_list';
export const UPDATE_LOGIN_TYPE = 'update_login_type';
export const SWITCH_ROLE = 'switch_role';
export const SWITCH_SERVER = 'switch_server';
export const UPDATE_PRODUCT_LIST = 'update_product_list';
export const UPDATE_PRODUCT_TYPES = 'update_product_types';
export const GET_PRODUCT_LIST = 'get_product_list';
export const UPDATE_LOADING_STATE = 'update_loading_state';
export const GET_LASTED_STORE_ROLE = 'get_lasted_store_role';
export const UPDATE_AREA_LIMIT = 'update_area_limit';

export const SWITCH_LANGUAGE = 'switch_language';
export const setLanguage = languages.setLanguage;

const HTTP = 'https:';
export const HOME_PAGE = `https://www.${mainHost}`;
export const DEFAULT_ICON = `//gabres.${mainHost}/commonImg/storeDefault/${mainHost}.png`;

const GET_GAME_LIST = `https://gstore.${mainHost}/ajax/game_list_history`;
const CHECK_LOGIN = 'center/ajax/get_store_user_json';
const LOGOUT_ACTION = `https://gpassport.${mainHost}/web_login/logout`;
const FETCH_GAME_INFO = `https://gstore.${mainHost}/ajax/game_info`;
const GET_LASTED_STORE_ROLE_ACTION = `https://gstore.${mainHost}/last_pay_info`;
export const GET_SERVER_LIST_ACTION = `https://gstore.${mainHost}/ajax/server_list_history`;
export const GET_ROLE_LIST_ACTION = `https://gstore.${mainHost}/ajax/get_user_role`;
export const GET_PRODUCT_LIST_ACTION = `https://gstore.${mainHost}/init_data`;
let lastServerId = null;
export const GOOGLE_RECAPTCHA_KEY = '6Lc92KQUAAAAAF-m6BIUOeHs1uobQNlOwn1_vJk7';
export const CHANNEL_NAME = {
  facebook: 'Facebook',
  line: 'Line',
  naver: 'Naver',
  twitter: 'Twitter'
};
const VIP_COUPON_INFO_ACTION = `https://gstore.${mainHost}/coupon/send_coupons`;
/**
  区天衡：
  由于新版支付页优惠券功能上线，PNS主力推广版本为全球版，为了优惠券通用性，需要将以下游戏ID支付页面进行重定向至全球版（ID191)
  台港澳版ID:225 韩语版ID:227 中东版ID:284
  越南版由于第三方支付特殊性，不需要作修改
 */
export const NEED_TRANS_TO_ZTMSLG_GAMES = [225, 227, 284];
export const ZTMSLG_GLOBAL_GAME_ID = 191;
export const NEED_TRANS_TO_ANTSLG_GAMES = [346];
export const ANTSLG_GLOBAL_GAME_ID = 263;
export const NEED_TRANS_TO_ZROUTER_GAMES = [454, 472];
export const ZROUTER_GLOBAL_GAME_ID = 454;
export const checkNeedTranToZtmslg = gameId => {
  return NEED_TRANS_TO_ZTMSLG_GAMES.includes(+gameId);
};
export const checkNeedTranToAntslg = gameId => {
  return NEED_TRANS_TO_ANTSLG_GAMES.includes(+gameId);
};
export const checkNeedTranToZrouter = gameId => {
  return NEED_TRANS_TO_ZROUTER_GAMES.includes(+gameId);
};
export const gameIdTransform = param => {
  if (Object.prototype.toString.call(param) === '[object Object]') {
    let gameId = param['gameId'] || param['game_id'] || param['gameID'];
    if (gameId && checkNeedTranToZtmslg(+gameId)) {
      if (param['gameId']) {
        param['gameId'] = ZTMSLG_GLOBAL_GAME_ID;
      }
      if (param['game_id']) {
        param['game_id'] = ZTMSLG_GLOBAL_GAME_ID;
      }
      if (param['gameID']) {
        param['gameID'] = ZTMSLG_GLOBAL_GAME_ID;
      }
    }
    if (gameId && checkNeedTranToAntslg(+gameId)) {
      if (param['gameId']) {
        param['gameId'] = ANTSLG_GLOBAL_GAME_ID;
      }
      if (param['game_id']) {
        param['game_id'] = ANTSLG_GLOBAL_GAME_ID;
      }
      if (param['gameID']) {
        param['gameID'] = ANTSLG_GLOBAL_GAME_ID;
      }
    }
    if (gameId && checkNeedTranToZrouter(+gameId)) {
      if (param['gameId']) {
        param['gameId'] = ZROUTER_GLOBAL_GAME_ID;
      }
      if (param['game_id']) {
        param['game_id'] = ZROUTER_GLOBAL_GAME_ID;
      }
      if (param['gameID']) {
        param['gameID'] = ZROUTER_GLOBAL_GAME_ID;
      }
    }
  }
  return param;
};

let matchRoleId = function (roleList, roleId) {
  let match = false;
  if (roleList != undefined && roleList.length > 0) {
    for (let i = 0; i < roleList.length; i++) {
      if (roleList[i].roleID == roleId) {
        match = true;
      }
    }
  }
  if (!match && roleList.length === 1) {
    roleId = roleList[0].roleID;
  }

  if (!match && roleList.length > 1) {
    roleId = null;
  }

  return roleId;
};

/**
 * 斗罗3D东南亚版为支持越南合作商FUNTAP支付页特殊档位价格，后台新增了部分商品ID。
 * 目前需要在泰国地区推广第三方页面，需要对这部分新增商品ID进行隐藏。
 */
const filterConfig = {
  // key：游戏ID value：过滤的商品ID
  274: [
    'dl3dvn.app.coin_35',
    'dl3dvn.app.coin_100_1',
    'dl3dvn.app.coin_100_2',
    'dl3dvn.app.coin_100_3',
    'dl3dvn.app.coin_100_4',
    'dl3dvn.app.coin_500_1',
    'dl3dvn.app.coin_1000_1',
    'dl3dvn.app.coin_2050_1',
    'dl3dvn.app.coin_2050_2',
    'dl3dvn.app.coin_5000_1',
    'dl3dvn.app.coin_10000_1',
    'dl3dvn.app.coin_10000_2'
  ]
};
const filterProductList = (filterConfig, originProductList) => {
  // 需要过滤
  if (filterConfig && /array/i.test(filterConfig.constructor.toString())) {
    return originProductList.filter(item => {
      return !filterConfig.includes(item.PRODUCT_ID);
    });
  }
  // 不需要过滤
  return originProductList;
};

window?.globalUpdateCommonParamsInfo?.({
  language: languages.language
});

export default {
  state: {
    gameId: null,
    gameLogo: '',
    gameList: [],
    gameHistory: [],
    thirdList: [],
    serverList: null,
    historyServerList: null,
    roleList: null,
    serverId: null,
    roleId: null,
    uid: globalConfig.getLclStorageItem('lid') || '',
    productList: [],
    productTypes: [],
    loadingProduct: false,
    lastedServerId: '',
    lastedRoleId: '',
    lastedRoleName: '',
    lastedGame: '',

    userName: '',
    userId: '',
    userPhoto: '',

    userAccount: '',
    password: '',
    repassword: '',
    isRemember: 1,
    loginType: '',

    userAccountState: true,
    passwordState: true,
    repasswordState: true,
    registerTermState: true,

    letter: languages.getAll(),
    lang: languages.language,
    langList: languages.getLangText(),
    isRtlDirection: languages.isRtlDirection(),

    userAccountTips: '',
    passwordTips: '',
    repasswordTips: '',
    loginRequest: '',
    registerTermTips: '',
    registerRequest: '',

    showCurrency: '',
    currentLocation: '',

    zipCode: '',
    locationModifyCount: 0,
    maxLocationModifyCount: 0,
    ipLocation: ''
  },
  mutations: {
    // 更新游戏id
    [UPDATE_GAMEID](state, gameid) {
      state.gameId = gameid;
    },
    // 更新游戏列表
    [UPDATE_GAME_LIST](state, gameList) {
      state.gameList = gameList;
    },
    [UPDATE_GAME_HISTORY](state, gameList) {
      state.gameHistory = gameList;
    },

    // 更新用户信息
    [UPDATE_USER_INFO](state, data) {
      state.userName = data.LOGIN_ACCOUNT;
      state.userId = data.UID;
    },
    // 更新用户名
    [UPDATE_USER_ACCOUNT](state, username) {
      state.userAccount = username;
    },
    // 更新记住账号
    [UPDATE_REMEMBER](state, isRemember) {
      state.isRemember = isRemember;
    },
    // 更新登录方式
    [UPDATE_LOGIN_TYPE](state, loginType) {
      state.loginType = loginType;
    },
    // 切换语言
    [SWITCH_LANGUAGE](state) {
      state.letter = languages.getAll();
      state.lang = languages.language;
      state.isRtlDirection = languages.isRtlDirection();
    },
    // 切换服务器
    [SWITCH_SERVER](state, id) {
      state.serverId = id;
    },
    // 切换角色
    [SWITCH_ROLE](state, id) {
      state.roleId = id;
    },
    // 获取商品列表
    [UPDATE_PRODUCT_LIST](state, productList) {
      state.productList = productList;
    },
    [UPDATE_PRODUCT_TYPES](state, typeList) {
      state.productTypes = typeList;
    },
    [GO_BACK_SELECT_GAME](state) {
      state.gameId = null;
      state.serverList = null;
      state.historyServerList = null;
      state.roleList = null;
      state.serverId = null;
      state.roleId = null;
      state.loadingProduct = false;
      state.productList = [];
    },
    // 更新伺服器列表
    [UPDATE_SERVER_LIST](state, serverList) {
      state.serverList = serverList;
    },
    [UPDATE_HISTORY_SERVER_LIST](state, historyServerList) {
      state.historyServerList = historyServerList;
    },
    // 更新角色列表
    [UPDATE_ROLE_LIST](state, roleList) {
      state.roleList = roleList;
    },
    [RESET_DATA](state) {
      state.userAccount = '';
      state.password = '';
      state.repassword = '';
      state.userAccountState = true;
      state.passwordState = true;
      state.repasswordState = true;
      state.registerTermState = true;
      state.userAccountTips = '';
      state.passwordTips = '';
      state.repasswordTips = '';
      state.registerTermTips = '';
    },
    [RESET_USER_INFO](state) {
      state.userName = '';
      state.userId = '';
      state.userPhoto = '';
    },
    [UPDATE_LOADING_STATE](state, type) {
      state.loadingProduct = type;
    },
    [UPDATE_UID](state, id) {
      state.uid = id;
    },
    updateShowCurrency(state, value) {
      state.showCurrency = value;
    },
    [UPDATE_LASTED_ROLE](state, params) {
      state.lastedGame = params.lastedGame;
      state.lastedServerId = params.lastedServerId;
      state.lastedRoleId = params.lastedRoleId;
      state.lastedRoleName = params.lastedRoleName;
    },
    updateGameLogo(state, value) {
      state.gameLogo = value;
    },
    updateCurrentLocation(state, value) {
      state.currentLocation = value;
    },
    [UPDATE_AREA_LIMIT](state, data) {
      state.zipCode = data?.zip_code || '';
      state.locationModifyCount = data?.location_modify_count || 0;
      state.maxLocationModifyCount = data?.max_location_modify_count || 0;
      state.ipLocation = data?.ip_location;
      state.defaultCurrency = data?.default_currency;
    }
  },
  getters: {
    // 根据搜索结果过滤商品列表
    getProductListByName: state => val => {
      return state.productList.filter(
        item =>
          item.CP_PRODUCT_DESC.toLowerCase().indexOf(val.toLowerCase()) !== -1
      );
    },
    getProductListByPrice: state => val => {
      return state.productList.filter(item => item.GAME_AMOUNT.includes(val));
    },
    isRtlDirection: state => {
      return state.isRtlDirection;
    }
  },
  actions: {
    // 获取游戏储值是否可用
    [GET_SEPC_GAME_INFO]({ commit }, { gameId }) {
      commit('updateGameLogo', '');
      return new Promise(resolve => {
        getJSON(FETCH_GAME_INFO, { game_id: gameId }).then(res => {
          if (parseInt(res.res.result, 10) === 1) {
            if (res.res.data && res.res.data.GAME_ID) {
              commit('updateGameLogo', res.res.data.PIC_URL);
              if (+res.res.data.WEB_THIRD_SWITCH === 1) {
                resolve(true);
              } else {
                resolve(false);
              }
            }
          } else {
            resolve(false);
          }
        });
      });
    },
    // 检查登录态
    [JUDGE_IS_LOGIN]({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        if (
          (globalConfig.getHrefParam('gameId') == 215 ||
            globalConfig.getHrefParam('game_id') == 215 ||
            globalConfig.getHrefParam('gameID') == 215) &&
          globalConfig.isUidGame()
        ) {
          resolve(1);
          return;
        }
        getJSON(HTTP + PASSPORT_HOST + CHECK_LOGIN, {}).then(res => {
          if (parseInt(res.res.result, 10) === 1) {
            commit(UPDATE_USER_INFO, res.res.data);
            commit(
              UPDATE_LOGIN_TYPE,
              res.res.data.LOGIN_TYPE ? res.res.data.LOGIN_TYPE : ''
            );
            updateDefaultParam('loginAccount', res.res.data.LOGIN_ACCOUNT);
            window?.globalUpdateCommonParamsInfo?.({
              uid: res.res.data.UID,
              loginAccount: res.res.data.LOGIN_ACCOUNT
            });
            window.sdkstoreDataLayer.push({
              eventName: 'login',
              eventType: res?.res?.data?.LOGIN_PATH || ''
            });
            // 针对 2（补款） | 3（大R支付）时，跳转到新版页面
            const loginType = res.res.data.LOGIN_TYPE || '';
            if ([2, 3].includes(loginType)) {
              // 跳转新版登录页
              // 获取当前的url与参数
              const search = window.location.search;
              const params = new URLSearchParams(search);
              if (params.has('isFromGs')) {
                // 存在则覆盖
                params.set('isFromGs', loginType == 3 ? '1' : '0');
              } else {
                // 不存在则添加
                params.append('isFromGs', loginType == 3 ? '1' : '0');
              }
              // 获取当前的MAINHOST
              const mainHost = globalConfig.getMainHost();
              if (loginType == 3) {
                // 大R支付的话清除登录态
                dispatch(GO_LOGOUT).then(() => {
                  window.location.href = `https://pay.${mainHost}/platform/officialTopupSupplement.html?${params}`;
                });
              } else {
                // 补款的话直接跳转补款页
                window.location.href = `https://pay.${mainHost}/platform/officialTopupSupplement.html?${params}`;
              }
            }
          }
          resolve(parseInt(res.res.result, 10) === 1);
        });
      });
    },
    // 更新游戏id
    [UPDATE_GAMEID]({ commit, dispatch }, param) {
      commit(UPDATE_GAMEID, parseInt(param, 10));
    },
    // 更新游戏列表
    [UPDATE_GAME_LIST]({ commit }) {
      return new Promise((resolve, reject) => {
        getJSON(GET_GAME_LIST, {}).then(res => {
          commit(UPDATE_GAME_LIST, res.data.all);
          commit(UPDATE_GAME_HISTORY, res.data.history);
          resolve();
        });
      });
    },
    // 登出
    [GO_LOGOUT]({ commit, state }) {
      return new Promise(resolve => {
        getJSON(LOGOUT_ACTION, {
          language: state.lang
        }).then(({ errmsg, res }) => {
          resolve({
            result: parseInt(res.result, 10) === 1
          });
        });
      });
    },
    // 更新伺服器列表
    [GET_SERVER_LIST]({ commit, state }) {
      return new Promise((resolve, reject) => {
        getJSON(
          GET_SERVER_LIST_ACTION,
          gameIdTransform({
            game_id: state.gameId,
            user_id_cross: state.uid || ''
          })
        ).then(res => {
          // 所有伺服器
          commit(UPDATE_SERVER_LIST, res.data.all);
          // 历史伺服器
          commit(UPDATE_HISTORY_SERVER_LIST, res.data.history);
          resolve(res.data);
        });
      });
    },
    // 更新角色列表
    [GET_ROLE_LIST]({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        getJSON(
          GET_ROLE_LIST_ACTION,
          gameIdTransform({
            game_id: state.gameId,
            server_id: param,
            user_id_cross: state.uid || ''
          })
        ).then(res => {
          commit(UPDATE_ROLE_LIST, res.data);
          if (res.data.length !== 0) {
            let realTargetRoleId =
              state.roleId || globalConfig.getHrefParam('roleId');
            let roleId = matchRoleId(state.roleList, realTargetRoleId);
            commit(SWITCH_ROLE, roleId);
          } else {
            commit(SWITCH_ROLE, null);
          }

          // 从 /ajax/get_user_role 接口返回数据查 state.roleId 是否有效
          let isRoleIdinResObj = res.data.filter(d => {
            return d.roleID == state.roleId;
          });
          let loadProductRightNow =
            res.data.length > 0 &&
            (isRoleIdinResObj.length ||
              state.roleId == globalConfig.getHrefParam('roleId'));

          resolve({
            loadProductRightNow,
            roleId: state.roleId
          });
        });
      });
    },
    // 获取商品列表
    [GET_PRODUCT_LIST]({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit(UPDATE_LOADING_STATE, 1);
        let serverInfo = state.serverList;
        let roleInfo = state.roleList;
        let sid = null;
        let roleName = null;
        for (let i = 0; i < serverInfo.length; i++) {
          if (serverInfo[i].ID == state.serverId) {
            sid = serverInfo[i].SID || '';
            break;
          }
        }
        for (let i = 0; i < roleInfo.length; i++) {
          if (roleInfo[i].roleID == state.roleId) {
            roleName = roleInfo[i].roleName || '';
            break;
          }
        }
        getJSON(
          GET_PRODUCT_LIST_ACTION,
          gameIdTransform({
            gameId: state.gameId,
            serverId: sid,
            roleId: state.roleId,
            roleName: encodeURIComponent(roleName),
            language: state.lang,
            user_id_cross: state.uid || '',
            h5: globalConfig.getHrefParam('pageSource') === 'h5' ? '1' : ''
          })
        ).then(res => {
          if (!res.data?.paytype_list?.length) {
            errorReport(ERROR_TYPE.PAY_TYPE_LIST_EMPTY);
          }
          if (!res.data?.product_list?.length) {
            errorReport(ERROR_TYPE.PRODUCT_LIST_EMPTY);
          }
          res.data.paytype_list = filterPayType(
            {
              gameId: state.gameId,
              location: res.data?.current_location
            },
            res.data.paytype_list
          );
          let productList = [];
          let productTypes = [];
          const initList = res.data.product_list;
          if (initList && initList.length !== 0) {
            initList.map(item => {
              productList = productList.concat(
                filterProductList(filterConfig[+state.gameId], item.list)
              );
              productTypes = productTypes.concat(item.catalog);
            });
            // productList = initList[1]
            //   ? [...initList[0].list, ...initList[1].list]
            //   : [...initList[0].list]
            // productTypes = initList[1]
            //   ? [initList[0].catalog, initList[1].catalog]
            //   : [initList[0].catalog]
          }

          commit(UPDATE_PRODUCT_LIST, productList);
          commit(UPDATE_PRODUCT_TYPES, productTypes);
          commit('updateShowCurrency', res.data.product_currency);
          commit('updateCurrentLocation', res.data.current_location);
          commit(UPDATE_LOADING_STATE, 0);
          commit(UPDATE_AREA_LIMIT, res.data);
          let loadProductRightNow;
          // 不同区服务可能会存在同样的roleId 的情况下重复加载产品项目
          resolve(loadProductRightNow);
        });
      });
    },
    // 更新用户名
    [UPDATE_USER_ACCOUNT]({ commit }, param) {
      commit(UPDATE_USER_ACCOUNT, param);
    },
    // 切换语言
    [SWITCH_LANGUAGE]({ commit, dispatch }, param) {
      languages.setLanguage(param);
      commit(SWITCH_LANGUAGE);
    },
    [GO_BACK_SELECT_GAME]({ commit }) {
      commit(GO_BACK_SELECT_GAME);
    },
    [RESET_USER_INFO]({ commit }) {
      commit(RESET_DATA);
      commit(RESET_USER_INFO);
    },
    [UPDATE_UID]({ commit }, param) {
      commit(UPDATE_UID, param);
      globalConfig.setLclStorageItem('lid', param);
    },
    [GET_LASTED_STORE_ROLE]({ commit, state }) {
      commit(UPDATE_LASTED_ROLE, {
        lastedServerId: '',
        lastedRoleId: '',
        lastedRoleName: '',
        lastedGame: ''
      });

      return new Promise((resolve, reject) => {
        getJSON(GET_LASTED_STORE_ROLE_ACTION, { game_id: state.gameId }).then(
          res => {
            if (res.res.result == 1 && res.data && res.data.ROLE_ID) {
              commit(UPDATE_LASTED_ROLE, {
                lastedGame: res.data.GAME_ID,
                lastedServerId: res.data.SERVER_ID,
                lastedRoleId: res.data.ROLE_ID,
                lastedRoleName: res.data.ROLE_NAME
              });
            }
            resolve();
          },
          reject
        );
      });
    },
    [UPDATE_AREA_LIMIT]({ commit }, data) {
      commit(UPDATE_AREA_LIMIT, data);
    }
  },
  modules: {
    logoConfig,
    webStoreCoupon
  }
};
